import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const uatSettings: Settings = {
  baseUrl: 'https://seed-insecta-api-uat.se.research.vylor.com',
  environment: 'uat',
  isProd: false,
  appInsightsConnectionString:
    'InstrumentationKey=48e57a26-4b79-4a82-bccc-b25effb7cec2;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=268ea6c1-7def-46c3-99dd-8cf1178a966c',
  msal: {
    config: {
      auth: {
        clientId: '018e09bd-0a75-43b8-809b-6f5cb863e5a9',
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01/',
        redirectUri: 'https://seed-insecta-uat.se.research.vylor.com/after-login',
        postLogoutRedirectUri: 'https://seed-insecta-uat.se.research.vylor.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://seed-insecta-api-uat.se.research.vylor.com', ['api://018e09bd-0a75-43b8-809b-6f5cb863e5a9/API.Call']]
      ])
    }
  }
};
